export const FETCH_USER_SUCCESS = 'user/FETCH_USER_SUCCESS';

export const fetchUserSuccess = (payload = {}) => ({
  type: FETCH_USER_SUCCESS,
  payload,
});
